import { isSupported as isFirebaseSupported } from "firebase/messaging";
import { useEffect } from "react";
import { WhoAmIResponse } from "../api/auth/whoAmI";
import { AppType } from "../constants/AppType";
import { getAppType } from "../getAppType";
import { useSettings } from "../settings/useSettings";
import { useWhoAmI } from "../user/useWhoAmI";
import { useShouldShowDarkMode } from "../api/settings/useShouldShowDarkMode";
import { useEvaluatedLocale } from "../localization/useEvaluatedLocale";
import { CvpLocale } from "../constants/CvpLocale";

// check if supported by browser before loading any of the firebase code
export async function useLoadFirebaseIfSupported() {
  if (getAppType() === AppType.iframe) return;
  if (window.iswtapp) return; // native app handles push notifications

  const settings = useSettings();

  const enablePush = settings.pwa_enabled;
  if (!enablePush) return;

  const { confirmedHasProfileInConcern, whoAmI } = useWhoAmI();
  const { darkMode } = useShouldShowDarkMode();
  const evaluatedLocale = useEvaluatedLocale();

  if (!confirmedHasProfileInConcern) return;

  useEffect(() => {
    loadFirebase(whoAmI, darkMode, evaluatedLocale);
  }, []);
}

let n = 0;
async function loadFirebase(
  whoAmI: WhoAmIResponse,
  darkmode: boolean,
  evaluatedLocale: CvpLocale
) {
  if (n++ > 0) return;

  const isSupported = await isFirebaseSupported();

  if (!isSupported) {
    console.error(
      `"a92209f08e1f" Firebase is not supported by browser. concernId=${whoAmI.concernId} idCandidate=${whoAmI.idCandidate}`,
      window.navigator.userAgent
    );
    return;
  }

  const module = await import("./pushNotifications");
  module.initializePushNotifications(whoAmI, darkmode, evaluatedLocale);
}
